module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ge-7ccc29e2355cf25d55c56b48a81588b1.svg";